import { InformationCircleIcon } from "@heroicons/react/outline";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverProps
} from "@cmp-src/primitives/Popover/Popover";
import React from "react";

export interface InformationPopoverProps
  extends React.PropsWithChildren<PopoverProps> {
  target?: React.ReactNode;
  width?: number;
  position?: "top" | "right" | "bottom" | "left";
}

export const InformationPopover: React.FC<InformationPopoverProps> = (
  props
) => {
  const { target, children, width = 300, position = "bottom", ...rest } = props;
  return (
    <Popover {...rest}>
      <PopoverTrigger asChild>
        <InformationCircleIcon className="ml-2 h-5 w-5 cursor-pointer text-neutral-400" />
      </PopoverTrigger>
      <PopoverContent side={position} style={{ width }} showArrow>
        {children}
      </PopoverContent>
    </Popover>
  );
};
